export const actions = {
  DESCUENTOS_LOAD_REQUESTED: 'DESCUENTOS_LOAD_REQUESTED',
  DESCUENTOS_LOAD_SUCCEEDED: 'DESCUENTOS_LOAD_SUCCEEDED',
  DESCUENTOS_LOAD_FAILED: 'DESCUENTOS_LOAD_FAILED',

  SET_DESCUENTO_USADO_REQUESTED: 'SET_DESCUENTO_USADO_REQUESTED',
  SET_DESCUENTO_USADO_SUCCEEDED: 'SET_DESCUENTO_USADO_SUCCEEDED',
  SET_DESCUENTO_USADO_FAILED: 'SET_DESCUENTO_USADO_FAILED',

  DELETE_DESCUENTO_REQUESTED: 'DELETE_DESCUENTO_REQUESTED',
  DELETE_DESCUENTO_SUCCEEDED: 'DELETE_DESCUENTO_SUCCEEDED',
  DELETE_DESCUENTO_FAILED: 'DELETE_DESCUENTO_FAILED',

  DESCUENTO_BYID_LOAD_REQUESTED: 'DESCUENTO_BYID_LOAD_REQUESTED',
  DESCUENTO_BYID_LOAD_SUCCEEDED: 'DESCUENTO_BYID_LOAD_SUCCEEDED',
  DESCUENTO_BYID_LOAD_FILED: 'DESCUENTO_BYID_LOAD_FILED',

  DESCUENTO_BYID_LOAD_INSERT_REQUESTED: 'DESCUENTO_BYID_LOAD_INSERT_REQUESTED',
  DESCUENTO_BYID_LOAD_INSERT_SUCCEEDED: 'DESCUENTO_BYID_LOAD_INSERT_SUCCEEDED',
  DESCUENTO_BYID_LOAD_INSERT_FILED: 'DESCUENTO_BYID_LOAD_INSERT_FILED',

  DESCUENTO_INSERT_REQUESTED: 'DESCUENTO_INSERT_REQUESTED',
  DESCUENTO_INSERT_SUCCEEDED: 'DESCUENTO_INSERT_SUCCEEDED',
  DESCUENTO_INSERT_FAILED: 'DESCUENTO_INSERT_FAILED',

  DESCUENTO_UPDATE_REQUESTED: 'DESCUENTO_UPDATE_REQUESTED',
  DESCUENTO_UPDATE_SUCCEEDED: 'DESCUENTO_UPDATE_SUCCEEDED',
  DESCUENTO_UPDATE_FAILED: 'DESCUENTO_UPDATE_FAILED',

  DESCUENTOS_FILTERED_LOAD_REQUESTED: 'DESCUENTOS_FILTERED_LOAD_REQUESTED',
  DESCUENTOS_FILTERED_LOAD_SUCCEEDED: 'DESCUENTOS_FILTERED_LOAD_SUCCEEDED',
  DESCUENTOS_FILTERED_LOAD_FAILED: 'DESCUENTOS_FILTERED_LOAD_FAILED',
}

export const getDescuentosAction = dispatch => {
  dispatch({
    type: actions.DESCUENTOS_LOAD_REQUESTED,
  })
}

export const setDescuentoUsadoAction = (dispatch, payloadDescuento) => {
  dispatch({
    type: actions.SET_DESCUENTO_USADO_REQUESTED,
    payload: payloadDescuento,
  })
}

export const deleteDescuentoAction = (dispatch, id) => {
  dispatch({
    type: actions.DELETE_DESCUENTO_REQUESTED,
    payload: id,
  })
}

export const getDescuentoCreateEditByIdAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.DESCUENTO_BYID_LOAD_REQUESTED,
      payload: id,
    })
  } else {
    dispatch({
      type: actions.DESCUENTO_BYID_LOAD_INSERT_REQUESTED,
    })
  }
}

export const onSubmitInsertDescuentoFormAction = (dispatch, formDescuento) => {
  dispatch({
    type: actions.DESCUENTO_INSERT_REQUESTED,
    payload: formDescuento,
  })
}

export const onSubmitUpdateDescuentoFormAction = (dispatch, formDescuento) => {
  dispatch({
    type: actions.DESCUENTO_UPDATE_REQUESTED,
    payload: formDescuento,
  })
}

export const getDescuentosFilteredAction = (dispatch, filter) => {
  dispatch({
    type: actions.DESCUENTOS_FILTERED_LOAD_REQUESTED,
    payload: filter,
  })
}
